import type { CopilotSettings } from "./types";
import { PANEL_DEFAULT_WIDTH } from "./types";

const KEY = "orkestria.copilot.settings.v1";

/**
 * Solo proveedor 'orkestria' está disponible públicamente.
 * El modelo y la API key viven en el backend.
 */
export const DEFAULT_SETTINGS: CopilotSettings = {
  providerId: "orkestria",
  baseUrl: "",
  apiKey: "",
  model: "",
  mode: "follow",
  panelMode: "immersed",
  panelWidth: PANEL_DEFAULT_WIDTH,
  permission: "ask",
};

export function loadSettings(): CopilotSettings {
  if (typeof window === "undefined") return DEFAULT_SETTINGS;
  try {
    const raw = window.localStorage.getItem(KEY);
    if (!raw) return DEFAULT_SETTINGS;
    const parsed = JSON.parse(raw) as Partial<CopilotSettings>;
    // Forzamos providerId='orkestria' aun si localStorage tiene otra cosa
    // (de versiones anteriores del cliente).
    return {
      ...DEFAULT_SETTINGS,
      ...parsed,
      providerId: "orkestria",
      // Limpiamos campos antiguos que ya no se usan
      baseUrl: "",
      apiKey: "",
      model: "",
    };
  } catch {
    return DEFAULT_SETTINGS;
  }
}

export function saveSettings(s: CopilotSettings) {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.setItem(KEY, JSON.stringify(s));
  } catch {
    // ignore
  }
}
